<app-form-multi-select
    [options]="(options$ | async) || []"
    [value]="(currentValue$ | async) || []"
    (valueChange)="statusValueChange($event)"
    [defer]="0"
    [placeholder]="'ci.common.campaignId' | translate"
></app-form-multi-select>